export const welcomeDefaults = {
  tagline: 'A little closer to the land',
  introduction: 'Find your way, capture a moment, and make every stay part of your story.',
  firstArrival: 'Make yourself at home. There’s plenty to explore.',
  returningArrival: 'It’s good to have you back. Enjoy your time here.',
};
export const welcomeLimits = {tagline: 100, introduction: 400, firstArrival: 400, returningArrival: 400};
